import React, {useState} from 'react'
import { FaStarHalfAlt } from "@react-icons/all-files/fa/FaStarHalfAlt";
import { FaStar } from "@react-icons/all-files/fa/FaStar";
import { FaRegStar } from "@react-icons/all-files/fa/FaRegStar";


const StarRating = ({onSelect, rating, showNumber}) => {
    let [review, setReview] = useState(0)
    let [change, showChange] = useState(false)

    let Stars = ({ rating, onMouseOver, onClick}) => <>
    {[1,2,3,4,5].map((n,i) =>   <div key={i} onMouseOver={() => onMouseOver ? onMouseOver(n) : {}} onClick={() => onClick ? onClick(n) : {}}>
        {rating > n- 0.25 ? <FaStar /> :rating > n- 0.75 ? <FaStarHalfAlt /> : <FaRegStar />}
    </div>)} 
</>
    if (onSelect) return <div className='starRating'>
    <div className='starRating-select' onMouseOver={() => showChange(true)} onMouseOut={() => showChange(false)}>        
        <Stars rating={review} onMouseOver={setReview} onClick={onSelect} />
    </div>
</div>

return  <div className='starShow'>
<Stars rating={rating} /> {showNumber && <span className='reviewNum' >({showNumber}) {showNumber > 1 ? 'reviews': 'review'}</span>}
</div>
}

export default StarRating